// extracted by mini-css-extract-plugin
export default {"panel":"TabPanel_panel__4zGMa","panelHeader":"TabPanel_panelHeader__M6lxk","fn":"TabPanel_fn__EU70x","description":"TabPanel_description__Rb-KO"};